import React, { useState } from 'react'
import axios from 'axios'
import { Container, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Form, FormField, Input, Button, Icon } from 'semantic-ui-react'

const CreateGame = ({ goBack }) => {
    const [name, setName] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleChangeField = e => {
        const { value } = e.target
        setName(value)
    }

    const handleSaveClicked = () => {
        if (name === '') return
        const dict = { name }
        setIsLoading(true)
        axios.post('/api/game', dict).then((res) => {
            goBack()
        }).catch((err) => {
            console.log(`create game failed with error: ${err}`)
            alert(`Failure creating game, please try again. Error: ${err}`)
        })
    }

    const handleCancelClicked = () => {
        goBack()
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', minHeight: '100vh', padding: '20px' }}>
            <br />
            <Breadcrumb inverted size='large'>
                <BreadcrumbSection onClick={handleCancelClicked}>Games</BreadcrumbSection>
                <BreadcrumbDivider color='teal' icon='right chevron' />
                <BreadcrumbSection active>Create New Game</BreadcrumbSection>
            </Breadcrumb>
            <br /><br /><br />
            <Form inverted>
                <FormField control={Input} label='Game Name' name='name' value={name} placeholder='Game Name' onChange={handleChangeField} inverted input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }}/>}/>
            </Form>
            <br /><br />
            <Button inverted color='teal' style={{ marginRight: 15 }} onClick={handleSaveClicked} loading={isLoading}><Icon name='add'/>Create Game</Button>
            <Button inverted onClick={handleCancelClicked}>Cancel</Button>
        </Container>
    )
}

export default CreateGame